"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Dropdown = _styledComponents["default"].li.attrs(function () {
  return {
    className: "nav-item dropdown",
    id: "best-navbar-drowpdown"
  };
}).withConfig({
  displayName: "NavbarDropdown__Dropdown",
  componentId: "tfr0ja-0"
})(["&&&{&:hover > .dropdown-menu{display:block;}@media (min-width:767px){&.show,:hover{background:", ";box-shadow:inset 0 0 1px ", ";}background-color:", ";}}"], function (props) {
  return props.theme["mlb-secondary-blue"] + " !important";
}, function (props) {
  return props.theme["black"];
}, function (props) {
  return props.isActive ? props.theme["mlb-secondary-blue"] + " !important" : null;
});

var Title = _styledComponents["default"].a.attrs(function () {
  return {
    className: "nav-link dropdown-toggle",
    role: "button",
    "data-toggle": "dropdown",
    "aria-haspopup": "true",
    "aria-expanded": "false"
  };
}).withConfig({
  displayName: "NavbarDropdown__Title",
  componentId: "tfr0ja-1"
})(["&&&{font-size:1.125rem;::after{display:none;}@media (min-width:768px){&&&{color:", ";&:hover{cursor:pointer;}padding:1rem;}}@media (max-width:767px){&&&{padding-left:25px;background:", ";color:#7d7c7c !important;border-top:1px solid ", ";border-bottom:1px solid ", ";}}}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["mlb-secondary-blue"];
}, function (props) {
  return props.theme["black"];
}, function (props) {
  return props.theme["black"];
});

var Links = _styledComponents["default"].div.attrs(function () {
  return {
    className: "dropdown-menu",
    "aria-labelledby": "navbarDropdown"
  };
}).withConfig({
  displayName: "NavbarDropdown__Links",
  componentId: "tfr0ja-2"
})(["&&&{ul{list-style-type:none;padding:0;}@media (min-width:768px){background:", ";width:auto;border:1px solid ", " !important;margin:0 !important;box-shadow:0 4px 8px 0 rgba(0,0,0,0.5);border-radius:0 !important;li > a,div{padding-left:1.125rem !important;padding-right:1.125rem !important;white-space:nowrap;}}@media (max-width:767px){width:100%;color:", ";background:", ";display:block !important;margin:0 !important;padding:0 !important;li > a,div{padding-left:50px !important;}li:not(:last-child) > a,div{border-bottom:1px solid ", " !important;}}}"], function (props) {
  return props.theme["mlb-secondary-blue"];
}, function (props) {
  return props.theme["black"];
}, function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["mlb-blue"];
}, function (props) {
  return props.theme["black"];
});

var NavbarDropdown = function NavbarDropdown(_ref) {
  var title = _ref.title,
      children = _ref.children,
      isActive = _ref.isActive;
  return _react["default"].createElement(Dropdown, {
    isActive: isActive
  }, title ? _react["default"].createElement(Title, null, title) : null, _react["default"].createElement(Links, null, _react["default"].createElement("ul", null, children)));
};

NavbarDropdown.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].string]).isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  isActive: _propTypes["default"].bool
};
NavbarDropdown.defaultProps = {
  children: null,
  isActive: false
};
var _default = NavbarDropdown;
exports["default"] = _default;